import { createAction } from '@reduxjs/toolkit'

import { OpenBrandFanInfluencerIdentity } from '../types'

export const toggleIdentity = createAction<number>(OpenBrandFanInfluencerIdentity.TOGGLE)
